<template>
  <div class="timer">
    <span class="timer__counter">
      {{ formattedTimer }}
    </span>
  </div>
</template>

<script>
  export default {
    data: () => ({
      timer: null,
      intervalHandle: null,
    }),
    props: {
      timerAmount: {
        type: Number,
        required: true,
      },
      onlySeconds: {
        type: Boolean,
      },
    },
    watch: {
      timerAmount() {
        if (this.timer > 0) return;

        this.resetTimer();
      },
    },
    created() {
      this.resetTimer();
    },
    computed: {
      formattedTimer() {
        if (this.onlySeconds) {
          return this.timer <= 0 ? '' : this.addZero(this.getSeconds);
        }

        const hours = this.addZero(this.getHours);
        const minutes = this.addZero(this.getMinutes);
        const seconds = this.addZero(this.getSeconds);

        return `${hours}:${minutes}:${seconds}`;
      },
      getHours() {
        return Math.floor(this.timer / (3600 * 1000));
      },
      getMinutes() {
        return Math.floor((this.timer / (60 * 1000)) % 60);
      },
      getSeconds() {
        return Math.floor((this.timer / 1000) % 60);
      },
    },
    methods: {
      addZero(timeUnit) {
        return +timeUnit < 10 ? `0${timeUnit}` : timeUnit;
      },
      resetTimer() {
        const timerAmount = Math.floor(this.timerAmount / 1000) * 1000;

        this.timer = timerAmount > 0 ? timerAmount : 0;

        if (this.timer <= 0) return;

        // set up a new interval which will update
        // the timer once per second
        this.intervalHandle = setInterval(() => {
          // when the timer reaches 0, clear it
          if (this.timer <= 0) {
            clearInterval(this.intervalHandle);

            this.$emit('timerFinish');

            return;
          }

          this.timer = this.timer - 1000 > 0 ? this.timer - 1000 : 0;
        }, 1000);
      },
    },
    beforeDestroy() {
      clearInterval(this.intervalHandle);
    },
  };
</script>

<style scoped lang="scss">
  .timer {
    display: inline-block;
    position: relative;
    width: 60px;
    height: 32px;
    border-radius: 2px;
    color: #ffffff;
    font-size: 24px;

    &__counter {
      display: block;
      //
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
</style>
